import { DEFAULT_TXN_DISMISS_MS } from 'constants/misc'
import useActiveWeb3 from 'hooks/blockchain/useActiveWeb3'
import LibUpdater from 'hooks/transactions/updater'
import { useCallback, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'state/hooks'

import { useAddPopup } from '../application/hooks'
import { checkedTransaction, finalizeTransaction } from './actions'

export default function Updater() {
  const { networkId } = useActiveWeb3()
  const addPopup = useAddPopup()

  const dispatch = useAppDispatch()
  const onCheck = useCallback(
    ({ networkId, hash, blockNumber }) => dispatch(checkedTransaction({ networkId, hash, blockNumber })),
    [dispatch]
  )
  const onReceipt = useCallback(
    ({ networkId, hash, receipt }) => {
      dispatch(
        finalizeTransaction({
          networkId,
          hash,
          receipt: {
            blockHash: receipt.blockHash,
            blockNumber: receipt.blockNumber,
            contractAddress: receipt.contractAddress,
            from: receipt.from,
            status: receipt.status,
            to: receipt.to,
            transactionHash: receipt.transactionHash,
            transactionIndex: receipt.transactionIndex,
          },
        })
      )
      addPopup(
        {
          txn: { hash },
        },
        hash,
        DEFAULT_TXN_DISMISS_MS
      )
    },
    [addPopup, dispatch]
  )

  const state = useAppSelector((state) => state.transactions)
  const pendingTransactions = useMemo(() => (networkId ? state[networkId] ?? {} : {}), [networkId, state])

  return <LibUpdater pendingTransactions={pendingTransactions} onCheck={onCheck} onReceipt={onReceipt} />
}
